import { Component, OnInit } from '@angular/core';
import { AuthService } from '@psnb/services';
import { Router} from "@angular/router";

@Component({
  selector: 'nwt-power-supply401',
  templateUrl: './power-supply401.component.html',
  styleUrls: ['./power-supply401.component.scss']
})
export class PowerSupply401Component implements OnInit {
  userpermissions:any;
  messageTypes:number = 2;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
  if(this.userpermissions =='' && this.authService.isAuthorizedPSNBUser){
      this.messageTypes = 3;
      this.router.navigate(['/unauthorized']);
  }
  else if (this.userpermissions !='' && this.authService.isAuthorizedPSNBUser){
    this.router.navigate(['/']);
  } 
  else if (this.userpermissions =='' && !this.authService.isAuthorizedPSNBUser){
    this.router.navigate(['/unauthorized']);
    this.messageTypes = 4;
   } 
   else if (this.userpermissions !='' && !this.authService.isAuthorizedPSNBUser){
    this.router.navigate(['/unauthorized']);
    this.messageTypes = 4;
   } 
    //if (this.authService.isAuthorizedPSNBUser) this.router.navigate(['/']);
  }

}
